import { p as proxyCustomElement, H, h, a as Host } from './index.js';
import { s as slotFilled } from './p-rUtJRH95.js';
import { d as defineCustomElement$4 } from './p-BbTg3Car.js';
import { d as defineCustomElement$3 } from './p-BDIehgMZ.js';
import { d as defineCustomElement$2 } from './p-Trmgzgcp.js';
import { d as defineCustomElement$1 } from './p-KbTC_jnR.js';

const formFieldCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:flex;flex-direction:column;font-family:Open Sans;font-size:.875rem;font-weight:400;gap:.25rem;height:100%;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;position:relative;width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host([size=lg]) label>h3{color:var(--jw-theme-form-field-filled-color);font-family:Open Sans;font-size:1.125rem;font-weight:400;letter-spacing:-.0008em;line-height:1.5rem;margin:0}label{display:flex;flex-direction:column;gap:.25rem;height:100%;width:100%}.label{color:var(--jw-theme-form-label-color);display:flex;font-family:Open Sans;font-size:.875rem;font-weight:600;letter-spacing:-.0004em;line-height:1.25rem}.label span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.label .required-asterisk{color:var(--jw-theme-form-validation-error-color);margin-left:.125rem}.label .optional-text{color:var(--jw-theme-form-field-placeholder-color);font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;margin-left:.25rem}.label wui-tooltip{align-self:center;margin-left:.25rem}.description{color:var(--jw-theme-form-validation-default-color);display:flex;justify-content:space-between;margin-left:var(--form-field--description-left,0);transition:color .3s ease}.description span{font-family:Open Sans;font-size:.75rem;font-weight:400;letter-spacing:0;line-height:1rem}.description.error{color:var(--jw-theme-form-validation-error-color)}.description.warning{color:var(--jw-theme-form-validation-warning-color)}.highlight{align-items:center;align-self:stretch;background-color:var(--jw-theme-info-muted-message-bg-color);border-radius:.25rem;color:var(--jw-theme-info-muted-message-color);display:inline-flex;font-family:Open Sans;font-size:.875rem;font-weight:400;height:2rem;letter-spacing:-.0004em;line-height:1.25rem;padding:0 .5rem;width:fit-content}";

const WuiFormField = /*@__PURE__*/ proxyCustomElement(class WuiFormField extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.errorType = 'error';
        this.size = 'md';
        this.variant = 'default';
        this.value = '';
        this.disabled = false;
    }
    renderDescription() {
        if (!(this.errorMessage || typeof this.description === 'string' || slotFilled(this.elm, 'post-description'))) {
            return;
        }
        return (h("div", { class: `description${this.errorMessage && this.errorType ? ` ${this.errorType}` : ''}` }, h("wui-box", { align: "start", gutter: "2xs", orientation: "horizontal", justify: "center" }, this.errorMessage && (h("wui-icon", { name: this.errorType === 'error' ? 'alert-circle-filled' : 'alert-triangle-filled' })), h("span", null, this.errorMessage || (typeof this.description === 'string' ? this.description : ''))), h("slot", { name: "post-description" })));
    }
    render() {
        return (h(Host, { key: 'd1d4da1720657c144cc80f0dc61a29b31e962c09' }, h("label", { key: 'ba34333ad44e294286a531f74b9af9ee1a83d04d', "aria-hidden": !this.label }, typeof this.label === 'string' && (h("div", { key: '58a5f3682aed5fc52db420d9254db90d5af20ab6', class: "label" }, h("span", { key: '14af5a2d515707482aa585e7b1d21f9ad27a77fc' }, this.label || '\u200B'), this.requisite === 'required' && h("span", { key: '0a1dcfbd3104012736a057ead119d0d3b57573cd', class: "required-asterisk" }, "*"), this.requisite === 'optional' && h("span", { key: '7aa3756604487ae619936a1217d18f59bffe931e', class: "optional-text" }, "(Optional)"), this.tooltip && (h("wui-tooltip", { key: '33d9cc090871950dc58b5283a591a1632ffa8f58', label: this.tooltip }, h("wui-icon", { key: '5e14b54989db9ec7feacd4f3031a71a307191395', name: "help-filled" }))))), this.helperText && (h("div", { key: 'ddd8287d8ba96295a7cc62ab2f6fc46ee31a7762', class: "description" }, h("wui-box", { key: '19428a1767379231ad777c1793082d21c9e3eb02', align: "start", gutter: "2xs", orientation: "horizontal", justify: "center" }, h("span", { key: 'e88ccfac9c890ae4ab816ed891797121226ead48' }, this.helperText)))), this.size === 'lg' ? (h("h3", null, this.value)) : this.variant === 'highlight' ? (h("div", { class: "highlight" }, h("slot", null))) : (h("slot", null))), this.renderDescription()));
    }
    get elm() { return this; }
    static get style() { return formFieldCss; }
}, [257, "wui-form-field", {
        "label": [1],
        "description": [1],
        "helperText": [1, "helper-text"],
        "tooltip": [1],
        "requisite": [1],
        "errorMessage": [1, "error-message"],
        "errorType": [1, "error-type"],
        "size": [513],
        "variant": [513],
        "value": [1],
        "disabled": [516]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-form-field", "wui-box", "wui-icon", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiFormField);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiFormField as W, defineCustomElement as d };
